import { loadBrandConfig } from './loadBrandConfig'

/**
 * storyella / aurenovel 阅读器路由名称（运行时按域名确定）
 * - 域名含 scroll（如 test-scroll.storyella.top）：chapter-scroll（无限滚动）
 * - 其他域名（如 book.storyella.top）：chapter（翻页）
 */
const domainAwareReaderRouteName: 'chapter' | 'chapter-scroll'
  = typeof window !== 'undefined' && (window.location.hostname.includes('scroll') || window.location.hostname === 'localhost')
    ? 'chapter-scroll'
    : 'chapter'

/**
 * 阅读器路由名称（构建时确定）
 * - novelarc: chapter-scroll（无限滚动）
 * - talewave: chapter-scroll（无限滚动）
 * - storyella / aurenovel: 按域名运行时确定（见 domainAwareReaderRouteName）
 * - 其他品牌: chapter（翻页）
 */
export const READER_ROUTE_NAME = loadBrandConfig({
  superstory: 'chapter',
  rocnovel: 'chapter',
  oceread: 'chapter',
  ficmoon: 'chapter',
  storyella: domainAwareReaderRouteName,
  aurenovel: domainAwareReaderRouteName,
  florastory: domainAwareReaderRouteName,
  silktale: 'chapter-scroll',
  freefic: 'chapter-scroll',
  pearla: 'chapter-scroll',
  fictora: 'chapter',
  marinovel: 'chapter',
  talewave: 'chapter-scroll',
  moonpage: 'chapter-scroll',
  novelune: 'chapter-scroll',
  storlyn: 'chapter-scroll',
  novaris: 'chapter-scroll',
  novelyn: 'chapter',
  flipnovel: 'chapter-scroll',
  novelarc: 'chapter-scroll',
  novelsprig: 'chapter',
  novelmello: 'chapter',
}) as 'chapter' | 'chapter-scroll'
